export const TIME_OFFS_QUERY_KEY = 'timeOffs'
export const TIME_OFF_BY_ID_QUERY_KEY = 'timeOffById'
